import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { convertRangeFilter, withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_MATERIAL_OPAQUE',
  GET: 'GET_MATERIAL_OPAQUE',
  CREATE: 'CREATE_MATERIAL_OPAQUE',
  EDIT: 'EDIT_MATERIAL_OPAQUE',
  DELETE: 'DELETE_MATERIAL_OPAQUE',
  DUPLICATE: 'DUPLICATE_MATERIAL_OPAQUE',
  CLEAR_ERROR: 'CLEAR_ERROR_MATERIAL_OPAQUE',
};

export const listMaterialOpaque = (pageSize, page, sorted, search, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_MATERIAL_OPAQUE,
      params: {
        ...convertRangeFilter(filtered),
        search: search,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic === null ? null : (isPublic ? 'True' : 'False'),
      },
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createMaterialOpaque = (name, density, specificHeat, thermalConductivity, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('density', density);
  formData.set('specific_heat', specificHeat);
  formData.set('thermal_conductivity', thermalConductivity);
  formData.set('description', description);
  if (image) formData.set('image', image, `oq_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_MATERIAL_OPAQUE,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editMaterialOpaque = (id, name, density, specificHeat, thermalConductivity, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (density) formData.set('density', density);
  if (specificHeat) formData.set('specific_heat', specificHeat);
  if (thermalConductivity) formData.set('thermal_conductivity', thermalConductivity);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `oq_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_MATERIAL_OPAQUE}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteMaterialOpaque = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_MATERIAL_OPAQUE}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateMaterialOpaque = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_MATERIAL_OPAQUE}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const searchOpaqueMaterialOrAirGap = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return RestClient.request({
    method: 'get',
    url: `${Constants.API_MATERIAL}?type=airgap&type=opaque`,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  }).catch(err => Promise.reject(err.response.data));
};

export const clearErrorMaterialOpaque = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/material_opaque/material_actions.js